module.exports = "images/enfants_10.0b6769cc.png";